import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';

import store from '../../store';
import seluxLogo from '../../../icons/selux-logo';
import {selectSolarPrice} from '../../solar/solarSelectors';

@customElement('shared-specsheet-footer')
export class SharedSpecsheetFooter extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				position: absolute;
				bottom: 0;
				right: 0;
				left: 0;
			}

			.footer {
				font: var(--font-specsheet-small-light);
				display: flex;
				justify-content: space-between;
				margin: 0 var(--specsheet-large-gap);
				align-items: center;
			}

			.footer-text {
				width: 60%;
			}

			.logo {
				width: 78px;
				display: inline-block;
				vertical-align: bottom;
			}

			.address {
				font: var(--font-specsheet-small-light);
			}

			.address span {
				font: var(--font-specsheet-small-bold);
			}

			.date {
				font: var(--font-specsheet-small-light);

			}

			.price {
				font: var(--font-specsheet-small-light);
			}

			@media print {
				:host {
					position: absolute;
					bottom: 0px;
					right: 0;
					left: 0;
					margin: 0;
				}

				.footer {
					font: var(--font-specsheet-print-small-light);
					display: flex;
					justify-content: space-between;
					margin: 0;
					align-items: center;
					box-sizing: border-box;
					margin: 0;
					width: 100%;
				}

				.footer-text {
					flex: 3;
					width: 60%;
				}

				.logo {
					width: 78px;
					display: inline-block;
					vertical-align: bottom;
					flex: 1;
				}

			}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.family = state.status.family;
		this.southernHemisphare = state.solar.data?.project?.location?.latitude < 0;
	}

	render() {
		const s = this.state;
		return html`
			<div class="footer">
				<div class="flex-item footer-text">
					<p>
						${when(this.family === 'Aeto', () => html`
							${when(!this.southernHemisphare,
								() => html`${msg('Unshaded, alignment of luminaire head to the north. Reference day: winter 21.dec, summer 21.jul, spring/autumn: 21.sep')} ${selectSolarPrice(s)}<br>`,
								() => html`${msg('Unshaded, alignment of luminaire head to the south. Reference day: summer 21.dec, winter 21.jul, spring/autumn: 21.sep')} ${selectSolarPrice(s)}<br>`,
							)}
						`)}
						<trans-label key="TE_Footer" context="D.L"></trans-label>
					</p>
					<p class="address">
						<span>Selux GmbH, Volkmarstraße 18, D-12099 Berlin, T +49 30 72001-0, F -100, info@selux.com, www.selux.com</span>
					</p>
				</div>

				<div class="flex-item logo">
					<div class="logo">
						${seluxLogo}
					</div>
				</div>
			</div>
		`;
	}
}
